"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var systemAdminApi = _interopRequireWildcard(require("@/api/systemadmin.js"));
var _jsCookie = _interopRequireDefault(require("js-cookie"));
var _validate = require("@/utils/validate");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
var cache;
function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var r, c, a = Object.defineProperty, n = { __proto__: null, default: e }; if (Object(e) !== e) return n; if (cache || "function" != typeof WeakMap || (cache = new WeakMap()), cache) { if (cache.has(e)) return cache.get(e); cache.set(e, n); } for (c in e) "default" !== c && {}.hasOwnProperty.call(e, c) && ((r = a && Object.getOwnPropertyDescriptor(e, c)) && (r.get || r.set) ? a(n, c, r) : n[c] = e[c]); return n; }
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  name: 'index',
  data: function data() {
    var _this = this;
    var validatePass = function validatePass(rule, value, callback) {
      if (value === '') {
        callback(new Error('请再次输入密码'));
      } else if (value !== _this.pram.pwd) {
        callback(new Error('两次输入密码不一致!'));
      } else {
        callback();
      }
    };
    var JavaInfo = JSON.parse(_jsCookie.default.get('JavaInfo'));
    return {
      password: '',
      JavaInfo: JSON.parse(_jsCookie.default.get('JavaInfo')),
      pram: {
        account: JavaInfo.account,
        pwd: null,
        repwd: null,
        realName: JavaInfo.realName,
        id: JavaInfo.id
      },
      roleList: [],
      rules: {
        account: [{
          required: true,
          message: '请填管理员账号',
          trigger: ['blur', 'change']
        }],
        pwd: [{
          required: true,
          message: '请填管理员密码',
          trigger: ['blur', 'change']
        }],
        repwd: [{
          required: true,
          message: '确认密码密码',
          validator: validatePass,
          trigger: ['blur', 'change']
        }],
        realName: [{
          required: true,
          message: '管理员姓名',
          trigger: ['blur', 'change']
        }]
      }
    };
  },
  methods: {
    close: function close(formName) {
      this.$refs[formName].resetFields();
    },
    handlerSubmit: (0, _validate.Debounce)(function (formName) {
      var _this2 = this;
      this.$refs[formName].validate(function (valid) {
        if (valid) {
          systemAdminApi.adminUpdatePwd(_this2.pram).then(function (data) {
            _this2.$message.success('提交成功');
            _this2.$router.go(-1);
          });
        } else {
          return false;
        }
      });
    }),
    handlerPwdInput: function handlerPwdInput(val) {
      var _this3 = this;
      if (!val) {
        this.rules.pwd = [];
        this.rules.repwd = [];
        return;
      }
      this.rules.pwd = [{
        required: true,
        message: '请填管理员密码',
        trigger: ['blur', 'change']
      }, {
        min: 6,
        max: 20,
        message: '长度6-20个字符',
        trigger: ['blur', 'change']
      }];
      this.rules.repwd = [{
        required: true,
        message: '两次输入密码不一致',
        validator: function validator(rule, value, callback) {
          if (value === '') {
            callback(new Error('两次输入密码不一致!'));
          } else if (value !== _this3.pram.pwd) {
            callback(new Error('两次输入密码不一致!'));
          } else {
            callback();
          }
        },
        trigger: ['blur', 'change']
      }];
    }
  }
};